export type InstanceBadge = {
  name: string;
  borderHex: string;
  borderHexEncoded: string;
  textClass: string;
  dotClass: string;
  faviconHref: string;
};

const STAGING_BADGE_DEFAULTS = {
  borderHex: '#ffd000',
  borderHexEncoded: '%23ffd000',
  textClass: 'text-amber-600',
  dotClass: 'bg-amber-600',
  faviconHref: '/assets/images/favicon-highlight.svg',
} as const;

const LOCAL_BADGE = {
  name: 'Local',
  borderHex: '#ec4899',
  borderHexEncoded: '%23ec4899',
  textClass: 'text-pink-500',
  dotClass: 'bg-pink-500',
  faviconHref: '/assets/images/favicon-local.svg',
} as const;

export function getInstanceBadge(): InstanceBadge | null {
  const explicit = import.meta.env.VITE_INSTANCE_NAME;
  if (explicit) {
    return { name: explicit, ...STAGING_BADGE_DEFAULTS };
  }
  if (import.meta.env.DEV) {
    return LOCAL_BADGE;
  }
  return null;
}
